module.exports = __webpack_public_path__ + "img/brand_1.9feea175.png";